//==========================================================================
//common.js
//==========================================================================

//userAgent
//---------------------------------------------------------
function userAgent() {
  const ua = navigator.userAgent;
  const $body = $('body');

  if (ua.indexOf('iPhone') !== -1) {
    $body.addClass('is-view-sp is-iphone');
  } else if (ua.indexOf('iPod') !== -1 || (ua.indexOf('Android') !== -1 && ua.indexOf('Mobile') !== -1)) {
    $body.addClass('is-view-sp');
  } else if (ua.indexOf('iPad') !== -1 || ua.indexOf('Android') !== -1) {
    $body.addClass('is-view-tab');
  } else {
    $body.addClass('is-view-pc');
  }

  // Detect macOS
  if (ua.indexOf('Mac') !== -1 && ua.indexOf('iPhone') === -1 && ua.indexOf('iPad') === -1) {
    $body.addClass('is-mac');
  }
}



//userAgentIE
//---------------------------------------------------------
function userAgentIE() {
  const ua = window.navigator.userAgent.toLowerCase();
  const uaVersion = window.navigator.appVersion.toLowerCase();
  //ie
  if (ua.indexOf('msie') != -1 || ua.indexOf('trident') !== -1) {
    $('body').addClass('is-view-ie');
  }
}



//menu
//---------------------------------------------------------
function menu() {
  const $menuTrriger = $('.js-menu-trigger');
  const $menuTarget = $('.js-menu-target');
  const $menuBg = $('.js-menu-bg');
  const $menuClose = $('.js-menu-close-trigger');
  let scrollPosition;
  //menuTrriger
  $menuTrriger.on('click', function(){
    if(!$(this).hasClass('is-open')){
      $('.bottom-search-popup, .bottom-search-overlay').removeClass('is-active');
      $menuTrriger.addClass('is-open');
      $menuTarget.addClass('is-open');
      $menuBg.addClass('is-open');
      scrollPosition = $(window).scrollTop();
      $('body').addClass('is-locked').css({ 'top': -scrollPosition });
    } else {
      menuClose();
    }
  });
  //menuClose
  $menuClose.on('click', function(){
    menuClose();
  });
  //menuClose
  function menuClose () {
    $menuTrriger.removeClass('is-open');
    $menuTarget.removeClass('is-open');
    $menuBg.removeClass('is-open');
    $('body').removeClass('is-locked').css({ 'top': '' });
    window.scrollTo(0, scrollPosition);
  }
}


//drop down nav
//---------------------------------------------------------
function dropNav() {
  const $dropNavs = $('.js-drop-nav');

  $dropNavs.hover(function() {
    $(this).toggleClass('is-drop-nav-active');
  });
}


//header search focus
//---------------------------------------------------------
function headerSearchFocus() {
  const $body = $('body');
  const $header = $('.l-header');
  const $searchItem = $('.l-header-nav__item--search');
  const $searchTrigger = $('.l-header-nav__search-trigger');
  const $searchInput = $('.l-header-search-form__input');
  let hideTimeout = null;
  let isHeaderAnimating = false;

  function isSearchSuppressed() {
    return $body.hasClass('is-header-search-suppressed');
  }

  function suppressSearch() {
    $body.addClass('is-header-search-suppressed');
    $searchItem.removeClass('is-search-open');
  }

  function releaseSearchSuppression() {
    if (isHeaderAnimating) return;
    if ($searchItem.is(':hover')) return;
    $body.removeClass('is-header-search-suppressed');
  }

  function updateSearchDropdownPosition() {
    if (!$searchItem.length || !$searchTrigger.length || !$header.length) return;

    if (window.innerWidth <= 1024.888889) {
      $searchItem.css({
        '--search-dropdown-left': '',
        '--search-dropdown-top': '',
        '--search-dropdown-width': ''
      });
      return;
    }

    const headerRect = $header[0].getBoundingClientRect();
    const $contentInner = $('.l-header__inner.l-inner').first();
    const dropdownWidth = Math.min(400, Math.max(window.innerWidth - 32, 0));
    const maxLeft = Math.max(16, window.innerWidth - dropdownWidth - 16);
    const contentRight = $contentInner.length
      ? $contentInner[0].getBoundingClientRect().right
      : window.innerWidth - 16;
    const preferredLeft = contentRight - dropdownWidth;
    const clampedLeft = Math.min(Math.max(preferredLeft, 16), maxLeft);

    $searchItem.css({
      '--search-dropdown-left': `${clampedLeft}px`,
      '--search-dropdown-top': `${Math.round(headerRect.bottom)}px`,
      '--search-dropdown-width': `${dropdownWidth}px`
    });
  }

  function isInputFocused() {
    return $searchInput.length && $searchInput.is(':focus');
  }

  // Click to focus input
  $searchTrigger.on('click', function() {
    if (isSearchSuppressed()) return;

    updateSearchDropdownPosition();
    setTimeout(function() {
      $searchInput.focus();
    }, 100);
  });

  // Hover with delay on leave
  $searchItem.on('mouseenter', function() {
    if (isSearchSuppressed()) return;

    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    updateSearchDropdownPosition();
    $(this).addClass('is-search-open');
  });

  $searchItem.on('mouseleave', function() {
    releaseSearchSuppression();

    const $this = $(this);
    hideTimeout = setTimeout(function() {
      if (!isInputFocused()) {
        $this.removeClass('is-search-open');
      }
    }, 1000);
  });

  $header.on('transitionrun transitionstart', function(event) {
    if (event.originalEvent && event.originalEvent.propertyName !== 'transform') return;
    isHeaderAnimating = true;
    suppressSearch();
  });

  $header.on('transitionend transitioncancel', function(event) {
    if (event.originalEvent && event.originalEvent.propertyName !== 'transform') return;
    isHeaderAnimating = false;
    releaseSearchSuppression();
    updateSearchDropdownPosition();
  });

  $(window).on('resize', updateSearchDropdownPosition);
  $(window).on('scroll', function() {
    if (!isInputFocused()) {
      suppressSearch();
    }
  });

  updateSearchDropdownPosition();
}


//pagetop
//---------------------------------------------------------
function pagetop() {
  const pagetopTrigger = $('.js-pagetop');
  const footerBottom = $('.l-footer__bottom');
  const footer = $('.l-footer');

  pagetopTrigger.removeClass('is-fixed').css({ bottom: '' });

  $(window).on('scroll resize', function () {
    const scrollTop = $(window).scrollTop();
    const windowHeight = window.innerHeight;
    const isDesktop = window.innerWidth >= 1025;
    const epsilon = 1;

    const passed = scrollTop > 150;
    if (!passed) {
      pagetopTrigger.removeClass('is-fixed').css({ bottom: '' });
      return;
    }

    let bottomValue = '0px';

    if (isDesktop) {
      if (footerBottom && footerBottom.length) {
        const rect = footerBottom[0].getBoundingClientRect();
        if (rect.top < windowHeight) {
          const visibleHeight = Math.max(0, windowHeight - rect.top);
          bottomValue = `${visibleHeight}px`;
        }
      }
      pagetopTrigger
        .addClass('is-fixed')
        .css({ bottom: bottomValue });

    } else {
      let touchBottom = false;
      if (footer && footer.length) {
        const footerTop = footer[0].getBoundingClientRect().top + 75;
        touchBottom = footerTop <= windowHeight + epsilon;
      }

      if (touchBottom) {
        pagetopTrigger
          .removeClass('is-fixed')
          .css({ bottom: '' });
      } else {
        pagetopTrigger
          .addClass('is-fixed')
          .css({ bottom: bottomValue });
      }
    }
  });

  pagetopTrigger.on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 500);
    return false;
  });
}


// anker
// ---------------------------------------------------
function anchor() {
  const headerHeight = $('.l-header').outerHeight();
  $('.js-anchor[href^="#"]').click(function () {
    let href = $(this).attr('href');
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - headerHeight;
    $('html, body').animate({
      scrollTop: position
    },500);
    return false;
  });
}


//accordion
//---------------------------------------------------------

function initCommentToggle() {
  $('.js-toggle_cmt').each(function () {
    const $item = $(this);
    const $text = $item.find('.js-toggle_cmt-head');
    const $toggle = $item.find('.js-toggle_cmt-target');
    const $toggleTxt = $toggle.find('.c-comment__txt');
    const textEl = $text[0];

    // Check if text is actually overflowing (height-based)
    if (textEl && textEl.scrollHeight > textEl.clientHeight) {
      $toggle.show();
    } else {
      $toggle.hide();
    }

    $toggle.off('click').on('click', function () {
      const isOpen = $text.toggleClass('is-open').hasClass('is-open');
      $toggle.toggleClass('is-open');
      $toggleTxt.text(isOpen ? '折りたたむ' : '続きを読む');
    });
  });
}

// select
//---------------------------------------------------------
function customDropdown() {
  $(document)
    .off('click.customDropdown')
    .on('click.customDropdown', '.js-dropdown .c-form__select-toggle', function (e) {
      e.stopPropagation();
      const $cur = $(this).closest('.js-dropdown');
      $('.js-dropdown').not($cur).removeClass('is-open').find('.c-form__select-menu').removeClass('show');
      $cur.toggleClass('is-open').find('.c-form__select-menu').toggleClass('show');
    })
    .on('click.customDropdown', '.js-dropdown .c-form__select-menu li', function (e) {
      e.stopPropagation();
      const $li = $(this);
      const $dropdown = $li.closest('.js-dropdown');
      const $toggle = $dropdown.find('.c-form__select-toggle');
      const value = $li.data('value');
      const text = $li.text();
      $toggle.text(text).data('value', value).addClass('is-selected');
      $dropdown.find('select').val(value).trigger('change');
      $dropdown.removeClass('is-open').find('.c-form__select-menu').removeClass('show');
    })

  $(document).on('click.customDropdown', function () {
    $('.js-dropdown').removeClass('is-open').find('.c-form__select-menu').removeClass('show');
  })
}

function initPlayVideo() {
  $(".js-video").each(function () {
    var $wrap = $(this);
    var $thumb = $wrap.find(".c-video__thumb");
    var $iframe = $wrap.find("iframe");

    $thumb.on("click", function () {
      var src = $iframe.data("src");

      src += (src.indexOf("?") === -1 ? "?" : "&") + "autoplay=1";
      $iframe.attr("src", src);

      $thumb.fadeOut(300);
    });
  });
}
// Handle main nav and submenu toggle (mobile only)
function navMenu() {
  // Toggle main menu
  $(".js-toggle-menu").on("click", function (e) {
    e.preventDefault();

    // Only run on mobile/tablet (<= 1024px)
    if (window.innerWidth > 1024) return;

    const $parent = $(this).closest(".p-nav-category");
    const $menu = $parent.find(".p-nav-category__items");

    $menu.slideToggle(200);
    $parent.toggleClass("is-open");
  });

  // Toggle submenu
  $(".js-toggle-submenu").on("click", function (e) {
    e.preventDefault();

    const $parent = $(this).closest(".has-submenu");
    const $submenu = $parent.next(".p-nav-submenu");

    // Close all other submenus
    $(".p-nav-submenu").not($submenu).slideUp(200);
    $(".has-submenu").not($parent).removeClass("is-open");

    // Toggle current submenu
    $submenu.slideToggle(200);
    $parent.toggleClass("is-open");
  });
  // Toggle header nav submenu (mobile header menu)
$(".js-open-menu").on("click", function (e) {
  e.preventDefault();

  const $trigger = $(this);
  const $submenu = $trigger.next(".l-header-nav__sub");
  const isActive = $trigger.hasClass("is-active");

  $(".js-open-menu").not($trigger).removeClass("is-active");
  $(".l-header-nav__sub").not($submenu).removeClass("is-active");

  $trigger.toggleClass("is-active", !isActive);
  $submenu.toggleClass("is-active", !isActive);
});
}

function preventDupClick() {
  $(document).on('click', '.js-prevent-dup-click', function (e) {
    var $el = $(this);

    // Already locked → block
    if ($el.data('locked')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }

    // Lock immediately
    $el.data('locked', true);

    // Button / input
    if ($el.is('button, input[type="submit"], input[type="button"]')) {
      $el.prop('disabled', true);
      return true; // allow submit
    }

    // Link (<a>) → allow first navigation
    if ($el.is('a')) {
      $el.addClass('is-disabled');
      // DO NOT preventDefault here
      return true;
    }

    // Other elements
    $el.addClass('is-disabled');
    return true;
  });
}

//bottom search popup (mobile)
//---------------------------------------------------------
function bottomSearchPopup() {
  const $trigger = $('.js-bottom-search-trigger');
  const $popup = $('.bottom-search-popup');
  const $overlay = $('.bottom-search-overlay');
  const $input = $('.bottom-search-popup__input');
  const $close = $('.js-bottom-search-close');
  const $pagetop = $('.js-pagetop');

  function openSearch() {
    $popup.addClass('is-active');
    $overlay.addClass('is-active');
    $pagetop.addClass('is-search-hidden');
    var el = $input[0];
    el.focus();
    var len = el.value.length;
    el.setSelectionRange(len, len);
  }

  function closeSearch() {
    $popup.removeClass('is-active');
    $overlay.removeClass('is-active');
    $pagetop.removeClass('is-search-hidden');
  }

  $trigger.on('click', function () {
    if ($popup.hasClass('is-active')) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  $close.on('click', function () {
    closeSearch();
  });
}
function disableRightClickOnImages(selector = 'img') {
    document.addEventListener('contextmenu', function (e) {
        if (e.target.matches(selector)) {
            e.preventDefault();
        }
    });
}

//init
//---------------------------------------------------------
$(function(){
  userAgent();
  userAgentIE();
  menu();
  // dropNav();
  pagetop();
  anchor();
  initCommentToggle();
  customDropdown();
  initPlayVideo();
  navMenu();
  headerSearchFocus();
  bottomSearchPopup();

  preventDupClick();
  disableRightClickOnImages();
});
